import { render } from "./CategoriesSegmentView.vue?vue&type=template&id=1ddc3596&scoped=true"
import script from "./CategoriesSegmentView.vue?vue&type=script&lang=js"
export * from "./CategoriesSegmentView.vue?vue&type=script&lang=js"

import "./CategoriesSegmentView.vue?vue&type=style&index=0&id=1ddc3596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddc3596"]])

export default __exports__